(() => {
  const init = (root) => {
    if (!root || root.dataset.clampReady === 'true') return;
    root.dataset.clampReady = 'true';

    const body = root.querySelector('[data-text-clamp-body]');
    const fade = root.querySelector('[data-text-clamp-fade]');
    const btn = root.querySelector('[data-text-clamp-toggle]');
    if (!body || !btn) return;

    const more = btn.querySelector('[data-label-more]');
    const less = btn.querySelector('[data-label-less]');
    const icon = btn.querySelector('[class*="toggle-icon"]');
    const lines = Number(root.dataset.clampLines || 5);

    const lineHeightPx = () => {
      const styles = window.getComputedStyle(body);
      const lh = styles.lineHeight;
      if (lh && lh !== 'normal') {
        const parsed = parseFloat(lh);
        if (!Number.isNaN(parsed)) return parsed;
      }
      const fontSize = parseFloat(styles.fontSize) || 16;
      return fontSize * 1.55;
    };

    const collapsedPx = () => lines * lineHeightPx();

    const needsClamp = () => body.scrollHeight > collapsedPx() + 10;

    const setCollapsed = () => {
      const max = collapsedPx();
      root.dataset.expanded = 'false';
      root.style.setProperty('--text-clamp-max', `${max}px`);
      btn.hidden = false;
      btn.setAttribute('aria-expanded', 'false');
      if (fade) fade.hidden = false;
      if (more) more.hidden = false;
      if (less) less.hidden = true;
      if (icon) icon.textContent = '↓';
    };

    const setExpanded = () => {
      root.dataset.expanded = 'true';
      root.style.setProperty('--text-clamp-max', 'none');
      btn.setAttribute('aria-expanded', 'true');
      if (fade) fade.hidden = true;
      if (more) more.hidden = true;
      if (less) less.hidden = false;
      if (icon) icon.textContent = '↑';
    };

    const apply = () => {
      root.style.setProperty('--text-clamp-max', 'none');
      if (!needsClamp()) {
        root.dataset.expanded = 'true';
        btn.hidden = true;
        if (fade) fade.hidden = true;
        return;
      }
      if (root.dataset.expanded === 'true' && btn.getAttribute('aria-expanded') === 'true') {
        setExpanded();
      } else {
        setCollapsed();
      }
    };

    btn.addEventListener('click', () => {
      if (root.dataset.expanded === 'true') setCollapsed();
      else setExpanded();
    });

    apply();
    window.addEventListener('resize', apply, { passive: true });
  };

  const boot = () => {
    document.querySelectorAll('[data-text-clamp]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-text-clamp]')?.forEach(init);
    if (event.target.matches?.('[data-text-clamp]')) init(event.target);
  });
})();
